import { basicAxios } from "../../sevices/baseAxios";

export const addNewTemplate = async (data) => {
    // console.log(data, "de")
  const response = await basicAxios.post("/api/Template/AddTemplate", data);
  return response.data;
};
export const getUserTemplateByUserId = async (id) => {
  const response = await basicAxios.get(`/api/Template/GetTemplate?id=${id}`);
  return response.data;
};

export const getDeleteAllTemplate = async (id) => {
  const response = await basicAxios.delete(`/api/Template/DeleteTemplateById?id=${id}`);
  return response.data;
};

export const getAllTemplate = async (payload) => {
  const response = await basicAxios.get(`/api/Template/GetTemplates?pageSize=${payload.pageSize}&pageIndex=${payload.pageIndex}`);
  // console.log(payload,"uyuy");
  return response.data;
};

export const getFilterAllTemplate = async (data) => {
  const response = await basicAxios.post("/api/Template/FilterTemplates", data);
  return response.data;
};
